import styled from "styled-components";
import PrizeTemplate from "./prize-category/PrizeTemplate";
const PrizeCategory = ({ title, prizes }) => {
  return (
    <Div>
      <Category>
        <CategorySpan>{title}</CategorySpan>
      </Category>
      <Prizes>
        {prizes &&
          [...prizes]
            .sort((a, b) => Number(b.year) - Number(a.year))
            .map((x) => (
              <PrizeTemplate
                key={x.image}
                presenter={x.presenter}
                content={x.content}
                year={x.year}
                image={x.image}
              />
            ))}
      </Prizes>
    </Div>
  );
};
export default PrizeCategory;
const Div = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem;
  @media (min-width: 1100px) {
    grid-template-columns: 12rem minmax(0, 1fr);
    gap: 2.5rem;
  }
`;
const Category = styled.div`
  & > span {
    position: sticky;
    top: 7rem;
    display: block;
  }
`;
const Prizes = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 1rem;
`;
const CategorySpan = styled.span`
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.dark};
  padding-left: 0.85rem;
  border-left: 4px solid ${({ theme }) => theme.colors.accent};
`;
